function subMegaMenu() {
  var hoverTimeout;
  var $subMenuContainer = null;
  var $subMenuToggler = null;
  var $subMenuItem = null;

  var open = function () {
    clearTimeout(hoverTimeout);
    $subMenuContainer.siblings().removeClass('open');
    $subMenuContainer.addClass('open');
  }

  var close = function () {
    hoverTimeout = setTimeout(function () {
      $subMenuContainer.removeClass('open');
    }, 400);
  }

  var toggleOpen = function () {
    if ($subMenuContainer.hasClass('open')) {
      $subMenuContainer.removeClass('open');
    } else {
      $subMenuContainer.addClass('open');
    }

  }

  function checkOffset() {
    var expectedWidth = parseInt($subMenuItem.css('width'));
    var windowwidth = $(window).width();    
    if (windowwidth > expectedWidth && windowwidth - $subMenuContainer.offset().left <= expectedWidth) {
      $subMenuContainer.addClass('right');
    } else {
      $subMenuContainer.removeClass('right');
    }

  }


  $(window).on('resize', function () {
    checkOffset();
  });

  var bindElements = function () {
    $subMenuContainer.hover(function () {
      open();
    }, function () {
      close();
    });

    $subMenuToggler.click(function () {
      toggleOpen();
    })
  }

  var initSubMegaMenu = function (containerElement) {
    $subMenuContainer = $(containerElement);
    $subMenuToggler = $subMenuContainer.children('button');
    $subMenuItem = $subMenuContainer.children('.c-mega-menu-sub');
    bindElements();
    checkOffset();
  }

  return {
    initSubMegaMenu: initSubMegaMenu
  };
}

function subMegaMenuParent() {
  var $parentContainer = null;
  var $rootToggler = null;

  var toggleRootOpen = function () {
    $parentContainer.toggleClass('root-open');
  }

  var bindElements = function () {
    $rootToggler.click(function () {
      toggleRootOpen();
    })


  }

  var initSubMegaMenuParent = function (el) {
    $parentContainer = $(el);
    $rootToggler = $parentContainer.find('.js-root-toggler');
    bindElements();
  }

  return {
    initSubMegaMenuParent: initSubMegaMenuParent
  };
}

(function ($, document, window) {
  $(document).ready(function () {
    $('.c-mega-menu-sub-container').each(function (idx, el) {
      var smm = new subMegaMenu();
      smm.initSubMegaMenu(el);
    });

    $('.c-mega-menu-sub-parent').each(function (idx, el) {
      var smmp = new subMegaMenuParent();
      smmp.initSubMegaMenuParent(el);
    });
  });
}(jQuery, document, window));